import toast from 'react-hot-toast';
import { call, put, takeLatest } from 'redux-saga/effects';
import * as types from '../../../../constants/ActionNameConstants';
import { PROOFREADER_EDITOR_UNCLAIM_API_URL } from '../../../../constants/ApiUrlConstants';
import { MY_FILE_ROUTE } from '../../../../constants/RouteNameConstants';
import { postApiRequest } from '../../../../features/axiosClient';
import history from '../../../../features/history';
import { proofreaderUnClaimFailure, proofreaderUnClaimSuccess } from '../actions';

const proofreaderUnClaimAPI = (action) => postApiRequest(PROOFREADER_EDITOR_UNCLAIM_API_URL, action);

function forwardTo(location) {
  history.push(location);
}

function* handleProofreaderUnClaim(action) {
  try {
    const response = yield call(proofreaderUnClaimAPI, action.payload);
    if (response?.data?.success) {
      yield call(forwardTo, MY_FILE_ROUTE);
    }
    if (response?.data?.success && response?.data?.resultMessage !== '') {
      toast.success(response?.data?.resultMessage);
    }
    if (!response.data?.success) {
      toast.error(response?.data?.errorMessage);
    }
    yield put(proofreaderUnClaimSuccess(response));
  } catch (error) {
    yield put(proofreaderUnClaimFailure(error));
  }
}

export function* watchProofreaderUnClaim() {
  yield takeLatest(types.PROOFREADER_UNCLAIM_REQUEST, handleProofreaderUnClaim);
}
